<template>
  <section>
    <b-modal :active.sync="shouldShowFile">
      <p class="image is-4by3">
        <img :src="imageSrc">
      </p>
    </b-modal>

    <b-field class="file" v-if="!fileToUpload">
      <b-upload v-model="fileToUpload"
        accept="image/*">
        <a class="button is-primary">
          <span>Select a File</span>
        </a>
      </b-upload>
    </b-field>

    <div class="field">
      <b-tag v-if="fileToUpload"
        type="is-primary"
        attached
        closable
        @close="deleteSelected">
        {{ fileToUpload.name }}
      </b-tag>
    </div>

    <button class="button is-success" v-if="fileToUpload">
      <b-icon icon="upload"></b-icon>
      <span @click="startFileUpload">Start Upload</span>
    </button>

  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ApiUtil from '@/utils/ApiUtil';
import { S3_UPLOAD_CATEGORIES } from '@/utils/Enums';
import moment from 'moment';
import _ from 'lodash';

export default {
  props: {
    userId: {
      type: String,
      required: false,
      default: null,
    },
    prefix: {
      type: String,
      required: false,
      default: '',
    },
    s3UploadCategory: {
      required: true,
      validator: (c) => {
        return _.keys(S3_UPLOAD_CATEGORIES).indexOf(c) !== -1;
      },
    },
    method: { type: Function },
    isUploadShown: Boolean,
    isDeleteShown: Boolean,
    isViewShown: Boolean,
  },
  data() {
    return {
      imageSrc: null,
      fileToUpload: null,
      shouldShowFile: false,
      shouldShowFilePicker: false,
      s3UploadKey: '',
    };
  },
  components: {
  },
  computed: {
    ...mapState([
      'isLoading',
      'user',
    ]),
  },
  methods: {
    ...mapMutations([
      'setIsLoading',
    ]),
    async showFile() {
      this.imageSrc = await ApiUtil.getPresignedUrl({
        method: 'get',
        s3UploadKey: this.s3UploadKey,
      });
      this.shouldShowFile = true;
    },
    async deleteSelected() {
      this.fileToUpload = null;
    },
    async startFileUpload() {
      this.setIsLoading(true);
      const now = new Date();
      this.s3UploadKey = `${this.s3UploadCategory}-${this.prefix}-${moment(now).format('YYYYMMDDHHmmss')}`;
      const presignedUrl = await ApiUtil.getPresignedUrl({
        method: 'put',
        s3UploadKey: this.s3UploadKey,
      });
      const options = {
        headers: {
          'Content-Type': this.fileToUpload.type,
        },
      };
      const response = await ApiUtil.putS3(presignedUrl, this.fileToUpload, options);
      const key = this.s3UploadKey;
      this.$emit('uploadSuccess', {
        key,
        timestamp: now,
        s3UploadCategory: this.s3UploadCategory,
      });
      this.fileToUpload = null;
      this.setIsLoading(false);
    },
  },
};
</script>
